export interface ComicTag {
  id: string;
  name: string;
  color: string;
}

export interface ComicItem {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  categorySlug: string;
  tags: ComicTag[];
  description: string;
  rating: number;
  views: number;
  favorites: number;
  chapters: number;
  updateDate: string;
  status: '连载中' | '已完结';
}

export interface ComicDetail extends ComicItem {
  longDescription: string;
  chapters_list: ChapterItem[];
  relatedComics: ComicItem[];
}

export interface ChapterItem {
  id: string;
  title: string;
  updateDate: string;
  pageCount: number;
}

export interface CategoryInfo {
  slug: string;
  name: string;
  icon: string;
  count: number;
}

export const categories: CategoryInfo[] = [
  { slug: 'love', name: '恋爱', icon: 'ri-heart-line', count: 128 },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', count: 96 },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', count: 85 },
  { slug: 'mystery', name: '悬疑', icon: 'ri-search-eye-line', count: 64 },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', count: 72 },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line', count: 93 },
  { slug: 'bl', name: '耽美', icon: 'ri-star-line', count: 56 },
  { slug: 'gl', name: '百合', icon: 'ri-flower-line', count: 38 },
];

export const popularTags: ComicTag[] = [
  { id: 't1', name: '穿越', color: '#e85d75' },
  { id: 't2', name: '重生', color: '#f4a261' },
  { id: 't3', name: '校园', color: '#52b788' },
  { id: 't4', name: '职场', color: '#7b9ecc' },
  { id: 't5', name: '古风', color: '#c77dff' },
  { id: 't6', name: '总裁', color: '#e76f51' },
  { id: 't7', name: '逆袭', color: '#2a9d8f' },
  { id: 't8', name: '甜宠', color: '#f15bb5' },
];

const allComics: ComicItem[] = [
  {
    id: 'comic-001',
    title: '社内相亲',
    author: '朴美英',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20romance%20manhwa%20cover%20art%20style%2C%20elegant%20woman%20in%20office%20attire%20with%20soft%20warm%20lighting%2C%20romantic%20atmosphere%2C%20delicate%20illustration%20with%20clean%20simple%20background%2C%20pastel%20pink%20and%20cream%20tones%2C%20webtoon%20cover%20style%2C%20minimalist%20design&width=600&height=800&seq=comic-cover-001&orientation=portrait',
    category: '恋爱',
    categorySlug: 'love',
    tags: [{ id: 't3', name: '校园', color: '#52b788' }, { id: 't8', name: '甜宠', color: '#f15bb5' }],
    description: '平凡职场女性申夏莉，在一次替闺蜜相亲的过程中，意外发现对方竟是自己的公司社长姜泰武！一场啼笑皆非的"伪装相亲"就此展开。',
    rating: 9.5,
    views: 2850000,
    favorites: 156000,
    chapters: 128,
    updateDate: '2026-08-03',
    status: '连载中',
  },
  {
    id: 'comic-002',
    title: '我独自升级',
    author: '金光石',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20manhwa%20cover%20art%2C%20male%20warrior%20with%20glowing%20blue%20eyes%20and%20black%20armor%2C%20dramatic%20lighting%20with%20shadows%2C%20epic%20atmosphere%2C%20clean%20dark%20background%20with%20subtle%20magical%20effects%2C%20webtoon%20style%20illustration%2C%20intense%20and%20powerful%20composition&width=600&height=800&seq=comic-cover-002&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: [{ id: 't1', name: '穿越', color: '#e85d75' }, { id: 't7', name: '逆袭', color: '#2a9d8f' }],
    description: '被称为"人类最弱兵器"的成振宇，在一次地下城探险中濒临死亡后，获得了一个神秘的系统，从此开启了逆袭升级之路。',
    rating: 9.8,
    views: 5200000,
    favorites: 320000,
    chapters: 200,
    updateDate: '2026-08-03',
    status: '已完结',
  },
  {
    id: 'comic-003',
    title: '女神降临',
    author: '猫猫',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20romance%20comedy%20manhwa%20cover%2C%20beautiful%20young%20woman%20with%20perfect%20makeup%20looking%20in%20mirror%2C%20soft%20pink%20and%20warm%20lighting%2C%20cosmetics%20and%20beauty%20theme%2C%20clean%20pastel%20background%2C%20charming%20webtoon%20style%2C%20sweet%20and%20playful%20atmosphere&width=600&height=800&seq=comic-cover-003&orientation=portrait',
    category: '恋爱',
    categorySlug: 'love',
    tags: [{ id: 't3', name: '校园', color: '#52b788' }, { id: 't8', name: '甜宠', color: '#f15bb5' }],
    description: '因外貌被欺凌的高中生任朱静，通过化妆技巧华丽变身，成为校园女神。但她一直隐藏着自己的真实面貌，直到两个男孩闯入了她的生活。',
    rating: 9.3,
    views: 4100000,
    favorites: 245000,
    chapters: 156,
    updateDate: '2026-08-02',
    status: '连载中',
  },
  {
    id: 'comic-004',
    title: '全知读者视角',
    author: '金泰亨',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20action%20fantasy%20manhwa%20cover%2C%20male%20protagonist%20holding%20a%20ancient%20book%20with%20glowing%20symbols%2C%20apocalyptic%20cityscape%20background%20with%20subtle%20warm%20tones%2C%20dramatic%20composition%2C%20webtoon%20illustration%20style%2C%20mysterious%20and%20epic%20atmosphere&width=600&height=800&seq=comic-cover-004&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    tags: [{ id: 't1', name: '穿越', color: '#e85d75' }, { id: 't7', name: '逆袭', color: '#2a9d8f' }],
    description: '金独子是唯一读完了一部连载十年、共3149话的网络小说读者。当小说中的末世场景在现实中上演时，他成为了唯一知晓剧情走向的人。',
    rating: 9.7,
    views: 4800000,
    favorites: 298000,
    chapters: 189,
    updateDate: '2026-08-03',
    status: '连载中',
  },
  {
    id: 'comic-005',
    title: '某天成为公主',
    author: '李智恩',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20fantasy%20romance%20manhwa%20cover%2C%20princess%20in%20elegant%20pastel%20pink%20dress%20with%20golden%20crown%2C%20royal%20palace%20background%20with%20soft%20glowing%20light%2C%20delicate%20illustration%20style%2C%20dreamy%20and%20fairytale%20atmosphere%2C%20clean%20composition&width=600&height=800&seq=comic-cover-005&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: [{ id: 't5', name: '古风', color: '#c77dff' }, { id: 't1', name: '穿越', color: '#e85d75' }],
    description: '一觉醒来变成了小说中的悲情公主，知晓自己将在18岁被亲生父亲处死的命运。为了活下去，她决定做一个最乖最可爱的公主。',
    rating: 9.4,
    views: 3600000,
    favorites: 210000,
    chapters: 145,
    updateDate: '2026-08-01',
    status: '已完结',
  },
  {
    id: 'comic-006',
    title: '看脸时代',
    author: '朴泰俊',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20action%20drama%20manhwa%20cover%2C%20two%20contrasting%20male%20figures%20one%20handsome%20and%20one%20overweight%2C%20urban%20school%20setting%2C%20split%20composition%20showing%20duality%2C%20raw%20and%20realistic%20webtoon%20style%2C%20dramatic%20lighting%2C%20clean%20simple%20background&width=600&height=800&seq=comic-cover-006&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    tags: [{ id: 't3', name: '校园', color: '#52b788' }, { id: 't7', name: '逆袭', color: '#2a9d8f' }],
    description: '被霸凌的胖男孩朴亨锡，某天醒来发现自己拥有了一个完美的身体。白天用完美的身体，晚上回归原本的身体，两种截然不同的人生开始了。',
    rating: 9.1,
    views: 6300000,
    favorites: 380000,
    chapters: 220,
    updateDate: '2026-08-03',
    status: '连载中',
  },
  {
    id: 'comic-007',
    title: '再婚皇后',
    author: '金恩熙',
    cover: 'https://readdy.ai/api/search-image?query=A%20elegant%20Korean%20fantasy%20romance%20manhwa%20cover%2C%20queen%20in%20luxurious%20red%20and%20gold%20royal%20gown%2C%20imperial%20palace%20interior%20with%20warm%20candlelight%2C%20regal%20and%20dignified%20atmosphere%2C%20detailed%20illustration%2C%20webtoon%20style%20with%20classical%20elements&width=600&height=800&seq=comic-cover-007&orientation=portrait',
    category: '剧情',
    categorySlug: 'drama',
    tags: [{ id: 't5', name: '古风', color: '#c77dff' }, { id: 't6', name: '总裁', color: '#e76f51' }],
    description: '纳维亚皇后在丈夫东大帝国皇帝公然出轨后，毅然决定离婚。她提出了一个震惊整个帝国的条件——接受再婚，而对象是邻国的国王。',
    rating: 9.6,
    views: 4400000,
    favorites: 275000,
    chapters: 168,
    updateDate: '2026-08-02',
    status: '连载中',
  },
  {
    id: 'comic-008',
    title: '甜蜜家园',
    author: '金坎比',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20Korean%20horror%20thriller%20manhwa%20cover%2C%20apartment%20building%20with%20monster%20silhouette%20in%20shadow%2C%20ominous%20atmosphere%20with%20dark%20red%20and%20black%20tones%2C%20survival%20horror%20theme%2C%20webtoon%20style%20illustration%2C%20tense%20and%20eerie%20composition%20with%20clean%20background&width=600&height=800&seq=comic-cover-008&orientation=portrait',
    category: '悬疑',
    categorySlug: 'mystery',
    tags: [{ id: 't7', name: '逆袭', color: '#2a9d8f' }],
    description: '在末日般的公寓中，居民们必须对抗变成怪物的欲望。贤秀和幸存者们在这个封闭空间中，展开了绝望而顽强的生存斗争。',
    rating: 9.7,
    views: 5100000,
    favorites: 305000,
    chapters: 140,
    updateDate: '2026-08-03',
    status: '已完结',
  },
  {
    id: 'comic-009',
    title: '奶酪陷阱',
    author: '郑美京',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20campus%20romance%20mystery%20manhwa%20cover%2C%20young%20man%20and%20woman%20in%20university%20setting%2C%20subtle%20psychological%20tension%2C%20warm%20autumn%20color%20palette%2C%20clean%20and%20elegant%20webtoon%20style%2C%20soft%20natural%20lighting%2C%20intriguing%20atmosphere&width=600&height=800&seq=comic-cover-009&orientation=portrait',
    category: '悬疑',
    categorySlug: 'mystery',
    tags: [{ id: 't3', name: '校园', color: '#52b788' }, { id: 't8', name: '甜宠', color: '#f15bb5' }],
    description: '大学生洪雪发现完美学长刘正背后隐藏着不为人知的另一面。当她试图揭开真相时，卷入了一场危险的猫鼠游戏。',
    rating: 9.2,
    views: 3200000,
    favorites: 189000,
    chapters: 134,
    updateDate: '2026-07-30',
    status: '已完结',
  },
  {
    id: 'comic-010',
    title: '宫',
    author: '朴素熙',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20historical%20fantasy%20manhwa%20cover%2C%20princess%20and%20prince%20in%20traditional%20Korean%20hanbok%20inspired%20royal%20attire%2C%20palace%20garden%20with%20cherry%20blossoms%2C%20soft%20romantic%20lighting%2C%20elegant%20webtoon%20illustration%20style%2C%20dreamy%20atmosphere&width=600&height=800&seq=comic-cover-010&orientation=portrait',
    category: '恋爱',
    categorySlug: 'love',
    tags: [{ id: 't5', name: '古风', color: '#c77dff' }, { id: 't8', name: '甜宠', color: '#f15bb5' }],
    description: '在虚构的现代君主立宪制韩国，普通女高中生申彩静因祖父与先皇的约定，被迫与皇太子李信结婚，进入了一个陌生而华丽的皇室世界。',
    rating: 9.0,
    views: 2900000,
    favorites: 168000,
    chapters: 118,
    updateDate: '2026-07-28',
    status: '已完结',
  },
  {
    id: 'comic-011',
    title: '外貌至上主义',
    author: '李尚贤',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20school%20comedy%20drama%20manhwa%20cover%2C%20handsome%20male%20student%20with%20confident%20expression%2C%20school%20hallway%20background%2C%20bright%20and%20energetic%20atmosphere%2C%20youthful%20webtoon%20style%2C%20clean%20composition%20with%20warm%20lighting&width=600&height=800&seq=comic-cover-011&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: [{ id: 't3', name: '校园', color: '#52b788' }, { id: 't7', name: '逆袭', color: '#2a9d8f' }],
    description: '丑男一夜之间变成校草，他要用这副完美的外表征服校园！但这背后隐藏着怎样的代价？爆笑与感动交织的校园喜剧。',
    rating: 8.9,
    views: 1800000,
    favorites: 95000,
    chapters: 92,
    updateDate: '2026-08-02',
    status: '连载中',
  },
  {
    id: 'comic-012',
    title: '金秘书为何那样',
    author: '郑秀晶',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20office%20romance%20comedy%20manhwa%20cover%2C%20confident%20female%20secretary%20in%20professional%20attire%20and%20handsome%20CEO%2C%20modern%20office%20setting%2C%20bright%20and%20playful%20atmosphere%2C%20clean%20webtoon%20style%2C%20warm%20and%20charming%20composition&width=600&height=800&seq=comic-cover-012&orientation=portrait',
    category: '恋爱',
    categorySlug: 'love',
    tags: [{ id: 't4', name: '职场', color: '#7b9ecc' }, { id: 't6', name: '总裁', color: '#e76f51' }],
    description: '完美秘书金微笑在跟随自恋副会长李英俊9年后，突然提出辞职。副会长为了挽留她，展开了一系列令人啼笑皆非的追求攻势。',
    rating: 9.4,
    views: 3500000,
    favorites: 205000,
    chapters: 110,
    updateDate: '2026-08-01',
    status: '已完结',
  },
  {
    id: 'comic-013',
    title: '神之塔',
    author: '李宗范',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20action%20fantasy%20manhwa%20cover%2C%20mysterious%20tower%20rising%20into%20the%20sky%20with%20glowing%20floors%2C%20epic%20scale%2C%20adventure%20theme%2C%20dramatic%20composition%20with%20warm%20golden%20and%20dark%20tones%2C%20webtoon%20style%2C%20mysterious%20and%20grand%20atmosphere&width=600&height=800&seq=comic-cover-013&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: [{ id: 't1', name: '穿越', color: '#e85d75' }, { id: 't7', name: '逆袭', color: '#2a9d8f' }],
    description: '少年夜为了追寻唯一的朋友蕾哈尔，踏入传说中的神之塔。每一层塔都是一个世界，每一次攀登都是一场生死考验。',
    rating: 9.6,
    views: 4700000,
    favorites: 290000,
    chapters: 185,
    updateDate: '2026-08-03',
    status: '连载中',
  },
  {
    id: 'comic-014',
    title: '她的私生活',
    author: '金秀雅',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20romance%20comedy%20manhwa%20cover%2C%20young%20woman%20with%20camera%20in%20art%20gallery%20setting%2C%20playful%20and%20colorful%20atmosphere%2C%20bright%20webtoon%20style%20illustration%2C%20warm%20and%20cheerful%20composition%20with%20clean%20background&width=600&height=800&seq=comic-cover-014&orientation=portrait',
    category: '恋爱',
    categorySlug: 'love',
    tags: [{ id: 't4', name: '职场', color: '#7b9ecc' }, { id: 't8', name: '甜宠', color: '#f15bb5' }],
    description: '美术馆策展人成德美私下是狂热的偶像粉丝。当新馆长莱恩·金发现了她的秘密后，一段隐藏身份又互相吸引的浪漫故事就此展开。',
    rating: 9.1,
    views: 2100000,
    favorites: 128000,
    chapters: 98,
    updateDate: '2026-07-29',
    status: '已完结',
  },
  {
    id: 'comic-015',
    title: '恶女的定义',
    author: '崔罗熙',
    cover: 'https://readdy.ai/api/search-image?width=600&height=800&seq=comic-cover-015&orientation=portrait&query=A%20Korean%20fantasy%20drama%20manhwa%20cover%2C%20elegant%20noblewoman%20with%20sharp%20confident%20expression%20in%20dark%20red%20dress%2C%19th%20century%20European%20inspired%20setting%2C%20dramatic%20lighting%2C%20intense%20webtoon%20style%2C%20powerful%20and%20seductive%20atmosphere',
    category: '剧情',
    categorySlug: 'drama',
    tags: [{ id: 't5', name: '古风', color: '#c77dff' }, { id: 't6', name: '总裁', color: '#e76f51' }],
    description: '贵族小姐阿德莱德被告知自己是小说中的反派。为了改变被处决的命运，她决定抢在"女主角"之前行动起来，却意外改变了一切。',
    rating: 9.3,
    views: 2600000,
    favorites: 155000,
    chapters: 132,
    updateDate: '2026-08-02',
    status: '连载中',
  },
  {
    id: 'comic-016',
    title: '疯狂夏日',
    author: '尹多恩',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20youth%20comedy%20manhwa%20cover%2C%20group%20of%20young%20friends%20at%20summer%20beach%2C%20bright%20sunny%20atmosphere%2C%20fun%20and%20carefree%20vibe%2C%20colorful%20webtoon%20style%2C%20clean%20and%20refreshing%20composition&width=600&height=800&seq=comic-cover-016&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: [{ id: 't3', name: '校园', color: '#52b788' }],
    description: '五个高中好友在最后一个暑假的疯狂冒险。爱情、友情、梦想在炎热的夏天交织碰撞，笑中带泪的青春故事。',
    rating: 8.7,
    views: 1200000,
    favorites: 72000,
    chapters: 65,
    updateDate: '2026-07-25',
    status: '连载中',
  },
];

export const getComicById = (id: string): ComicDetail | undefined => {
  const comic = allComics.find((c) => c.id === id);
  if (!comic) return undefined;

  const chapters_list: ChapterItem[] = Array.from({ length: Math.min(comic.chapters, 20) }, (_, i) => ({
    id: `${id}-ch-${comic.chapters - i}`,
    title: `第${comic.chapters - i}话`,
    updateDate: new Date(2026, 6, 30 - i).toISOString().split('T')[0],
    pageCount: Math.floor(Math.random() * 30) + 15,
  }));

  const relatedComics = allComics
    .filter((c) => c.id !== id && c.category === comic.category)
    .slice(0, 6);

  return {
    ...comic,
    longDescription: `${comic.description} 这部作品自连载以来，凭借精彩的剧情和细腻的画风吸引了大量读者。作者以其独特的叙事风格，将人物的情感刻画得淋漓尽致，让读者沉浸其中欲罢不能。每一话都充满了惊喜与感动，是韩漫爱好者不可错过的佳作。`,
    chapters_list,
    relatedComics,
  };
};

export const getComicsByCategory = (slug: string): ComicItem[] => {
  const category = categories.find((c) => c.slug === slug);
  if (!category) return [];
  return allComics.filter((c) => c.categorySlug === slug);
};

export const getPopularComics = (limit: number = 8): ComicItem[] => {
  return [...allComics].sort((a, b) => b.views - a.views).slice(0, limit);
};

export const getLatestComics = (limit: number = 8): ComicItem[] => {
  return [...allComics].sort((a, b) => b.updateDate.localeCompare(a.updateDate)).slice(0, limit);
};

export const getTopRatedComics = (limit: number = 10): ComicItem[] => {
  return [...allComics].sort((a, b) => b.rating - a.rating).slice(0, limit);
};

export const getAllComics = (): ComicItem[] => allComics;